import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  List,
  ListItem,
  Tooltip,
} from "@material-ui/core";

import StarIcon from "@material-ui/icons/Star";

import componentStyles from "assets/theme/views/admin/dashboard";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import HeaderHome from "./components/header";
import { useRoutes } from "hooks/useRoutes";
import {
  getRedirectLink,
  ItemText,
  updatedFavoriteItems,
  filterRepeatedMenus,
} from "./components/search";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import UtilsFncs from "utils/UtilsFncs";
import { updateFavoritos } from "redux/reducers/favoritosMenuReducer";
import { getFavoritesList } from "redux/reducers/favoritosMenuReducer";

import { useTour } from "@reactour/tour";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

function Home() {
  const { isOpen, setIsOpen, currentStep, setCurrentStep } = useTour();
  const { routesVision } = useRoutes();

  const classes = { ...useStyles(), ...useStylesCardDeck() };
  const viewMenu = JSON.parse(localStorage.getItem("viewsMenuUser"));
  const viewMenuVision = JSON.parse(
    localStorage.getItem("viewsMenuUserVision")
  );
  const views = viewMenuVision ? viewMenuVision : viewMenu;
  const viewsMenuUser = filterRepeatedMenus(views);

  const [items, setItems] = useState(viewsMenuUser);
  const [addingFavorite, setAddingFavorite] = useState(false);
  const favoritesRedux = useSelector((state) => state.favoritosMenu.favoritos);
  const [favorites, setFavorites] = useState(favoritesRedux);
  const snackbar = useSnackbar();
  const isMobile = UtilsFncs.IsMobile();
  const favoritoXS = useMemo(() => (isMobile ? 12 : 6), [isMobile]);
  const dispatch = useDispatch();
  const [userRoutes, setUserRoutes] = useState(routesVision);

  const verifyProfiles = JSON.parse(localStorage.getItem("userProfiles"));
  const verifyProfilesVision = JSON.parse(
    localStorage.getItem("userProfilesVision")
  );

  const addToFavorites = useCallback(
    async (menu) => {
      setAddingFavorite(true);
      const newValue = !menu?.Favorito;

      const object = {
        idMenu: menu.IdMenu.toString(),
        favorito: newValue?.toString(),
      };

      await Api.post("favorite-menu-update", "login", object, true)
        .then((res) => {
          if (res.Success) {
            const updatedItems = filterRepeatedMenus(
              updatedFavoriteItems(items, menu.IdMenu)?.map((item) => {
                return {
                  ...item,
                  Favorito: favoritesRedux.some((favRedux) => {
                    return (
                      favRedux.IdMenu === item.IdMenu &&
                      favRedux.IdMenu !== menu.IdMenu
                    );
                  }),
                };
              })
            );
            const vision = localStorage.getItem("userVision");
            const saveItem = vision ? "viewsMenuUserVision" : "viewsMenuUser";
            setItems(updatedItems);
            localStorage.setItem(saveItem, JSON.stringify(updatedItems || []));
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
        })
        .finally(() => setAddingFavorite(false));
    },
    [favoritesRedux, items, snackbar]
  );

  useEffect(() => {
    if (routesVision) {
      setUserRoutes(routesVision);
    }
  }, [routesVision]);

  useEffect(() => {
    if (items) {
      const updatedFavorites = getFavoritesList(items);

      setFavorites(updatedFavorites);
      dispatch(updateFavoritos(updatedFavorites));
    }
  }, [dispatch, items]);

  useEffect(() => {
    if (!UtilsFncs.ArrayEquals(favoritesRedux, favorites)) {
      setFavorites(favoritesRedux);
    }
  }, [favoritesRedux]);

  useEffect(() => {
    const profile = verifyProfilesVision
      ? verifyProfilesVision
      : verifyProfiles;
    profile?.map((profile) => {
      if (
        profile?.NomePerfil === "ADM" ||
        profile?.NomePerfil === "LOJA_MM" ||
        profile?.NomePerfil === "LOJA_ADM_MM" ||
        profile?.NomePerfil === "LOJA"
      ) {
        const verifyTutorialStepOne = localStorage.getItem("homeStep1");
        const verifyTutorialStepTwo = localStorage.getItem("homeStep2");
        const verifynotificationTour = localStorage.getItem("notificationTour");
        const verifyTour = localStorage.getItem("openMenu");

        if (
          !verifyTutorialStepTwo &&
          currentStep === 1 &&
          verifyTour &&
          !verifynotificationTour
        ) {
          if (!verifyTutorialStepOne) {
            setCurrentStep(0);
          }
        }

        if (isOpen && verifyTutorialStepOne && verifyTutorialStepTwo) {
          setIsOpen(false);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return (
    <>
      <HeaderHome />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid item xs={favoritoXS}>
          <Card data-tut="reactour__step2">
            <CardHeader
              title="Favoritos"
              titleTypographyProps={{
                component: Box,
                marginBottom: "0!important",
                variant: "h3",
              }}
            ></CardHeader>
            <CardContent>
              <Grid container alignItems="center">
                <Grid item xs={12}>
                  <PerfectScrollbar
                    options={{
                      suppressScrollX: true,
                      useBothWheelAxes: false,
                    }}
                    style={{ maxHeight: 350, paddingRight: "1rem" }}
                  >
                    <List>
                      {favorites
                        ? favorites?.map((item, key) => {
                            return (
                              <ListItem
                                key={key}
                                button
                                component={Link}
                                to={getRedirectLink(userRoutes, item)}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Tooltip title={item.NomeMenu}>
                                    <ItemText text={item.NomeMenu} />
                                  </Tooltip>
                                  <IconButtonLoader
                                    title={
                                      item.Favorito
                                        ? "Desfavoritar"
                                        : "Favoritar"
                                    }
                                    extraStyle={{ marginLeft: "1rem" }}
                                    icon={
                                      item.Favorito ? (
                                        <StarIcon
                                          className="favStar"
                                          fontSize="large"
                                          color="primary"
                                        />
                                      ) : null
                                    }
                                    disabled={addingFavorite}
                                    onClick={() => addToFavorites(item)}
                                    name="favAction"
                                  />
                                </Box>
                              </ListItem>
                            );
                          })
                        : null}
                    </List>
                  </PerfectScrollbar>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Container>
    </>
  );
}

export default Home;
